
























import { Component, Vue } from 'vue-property-decorator';
import { SideBar, Breadcrumb, MenuDrawer, AppMain, TagsView, TopBar, LogModal } from './components';
import { getCompanyAllActiveUser } from '@/utils/user';
import { clearScheduleJob } from '@/utils/schedule';
import {
  registerCheckTodoSchedule, registerSettlementModuleSchedule, registerRemindByNewTodo,
  remindByTodayTodo, registerRemindByAcceptTodo,
} from '@/utils/remind';

@Component({
  components: {
    SideBar,
    Breadcrumb,
    // MenuDrawer,
    TagsView,
    AppMain,
    TopBar,
    LogModal,
  },
})
export default class Layout extends Vue {
  private contentHeight: string = '960px';
  private readyData: boolean = false;
  private refreshLoading: boolean = false;
  private created() {
    this.readyData = true;
    getCompanyAllActiveUser().then((res) => {
      this.readyData = false;
    }).catch((err) => {
      this.readyData = false;
      this.$message.warning(err);
    });
  }
  private beforeMount() {
    this.resizeHandler();
    window.addEventListener('resize', this.resizeHandler);
  }
  private mounted() {
    remindByTodayTodo();
    registerRemindByNewTodo();
    registerCheckTodoSchedule();
    registerSettlementModuleSchedule();
    registerRemindByAcceptTodo();
  }
  private beforeDestroy() {
    clearScheduleJob();
  }
  private resizeHandler() {
    const HEADER_HEIGHT = 48;
    this.contentHeight = (document.documentElement.clientHeight - HEADER_HEIGHT) + 'px';
  }
  private globalRefreshLoading(isShow: boolean) {
    this.readyData = isShow;
  }
}
